/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RemoveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconDelete from 'DesignSystem/Svgs/TysiaIconDelete/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RemoveAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/OrthodonticCoverage/RemoveOrAddAction/RemoveAction"
  
}) {
let globalCurrentLocationPermissionsHasPatientInsuranceEditValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_insurance_edit',
format: fromFormat.not,
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 data="global.current_location.permissions.has_patient_insurance_edit"
 format="/Data/format.js not"
 disabled={globalCurrentLocationPermissionsHasPatientInsuranceEditValueData}
 onClick={onClick}
 size="small"
>
{childProps => (
<div
  data-testid="RemoveAction.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconDelete
  viewPath={`${viewPath}/TysiaIconDelete`}
 height={14}
 fill="white"
/>
<TysiaButtonText
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Remove"
/>
</div>
)}
</TysiaButton>
{children}
</React.Fragment>)
}